import React, {useState} from 'react';
import {faShareAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ButtonToolbar, Col, Form, Modal, Row} from 'react-bootstrap';
import {Action, ActionHref, Copy} from './buttons';
import twitter from '../components/analytics/twitter.png';
import facebook from '../components/analytics/facebook.png';

export const ShareModalAction = ({
  onClose,
  actionProps = {
    title: 'Share',
  },
  modalProps = {
    title: null,
    copyLink: null,
    fullScreenshotUrl: null,
    previewScreenshotUrl: null,
    twitterLink: null,
  },
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
    onClose && onClose();
  };

  return (
    <>
      <Action onClick={() => setIsModalOpen(true)}>
        <FontAwesomeIcon style={{marginRight: 6}} icon={faShareAlt} />
        {actionProps?.title}
      </Action>

      <Modal show={isModalOpen} onHide={closeModal} centered size={'lg'}>
        <Modal.Header closeButton>
          <Modal.Title>{modalProps?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalProps?.copyLink ? (
            <>
              <Row>
                <Col>
                  <h3>Get a public link</h3>
                </Col>
              </Row>
              <Form.Group as={Row} controlId="formPlaintextPassword">
                <Col sm="10">
                  <Form.Control readOnly value={modalProps.copyLink} />
                </Col>

                <Col>
                  <ButtonToolbar>
                    <div>
                      <Copy text={modalProps.copyLink} />
                    </div>
                  </ButtonToolbar>
                </Col>
              </Form.Group>
            </>
          ) : null}
          <Row>
            <Col>
              <h6>or share the report via socials</h6>
            </Col>
          </Row>
          {!!modalProps?.twitterLink || !!modalProps?.copyLink ? (
            <Form.Group as={Row}>
              <Col sm="7">
                {modalProps?.twitterLink && (
                  <>
                    <a target={'_blank'} href={modalProps?.twitterLink}>
                      <img src={twitter} style={{height: 40}} alt={'twitter'} />
                    </a>
                    &nbsp;
                  </>
                )}
                {modalProps?.copyLink && (
                  <a
                    target={'_blank'}
                    href={`https://www.facebook.com/sharer/sharer.php?u=${modalProps?.copyLink}`}
                  >
                    <img src={facebook} style={{height: 40}} alt={'facebook'} />
                  </a>
                )}
              </Col>
            </Form.Group>
          ) : null}

          {!!modalProps?.fullScreenshotUrl ? (
            <>
              <Row>
                <Col>
                  <h3>Get an image</h3>
                </Col>
              </Row>
              <Row>
                <h6>Compact version</h6>
              </Row>
              <Row>
                <Col md={6}>
                  <img
                    src={modalProps?.previewScreenshotUrl}
                    style={{width: '100%'}}
                    alt="Share preview screenshot"
                  />
                </Col>
                <Col className={'d-flex align-items-center'}>
                  <ActionHref blank href={modalProps?.previewScreenshotUrl}>
                    Open image ↗
                  </ActionHref>
                </Col>
              </Row>
              <Row>
                <h6>Extended version</h6>
              </Row>
              <Row>
                <Col md={6}>
                  <img
                    src={modalProps?.fullScreenshotUrl}
                    style={{width: '100%'}}
                    alt="Share screenshot"
                  />
                </Col>
                <Col className={'d-flex align-items-center'}>
                  <ActionHref blank href={modalProps?.fullScreenshotUrl}>
                    Open image ↗
                  </ActionHref>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};
